import React, { useState } from "react";
import FadeContainer from "./FadeContainer";
import PricingHeader from "./PricingHeader";
import {
  makeStyles,
  Typography,
  Box,
  TextField,
  Button,
  FormControlLabel,
  Radio,
  FormControl,
  RadioGroup,
  Collapse,
  Fade
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import { remCalc } from "../../../utils/helpers";
import LoadingCircle from "../../common/LoadingCircle";
import API from "../../../utils/axios";
import { useSnackbar } from "notistack";
import { logout } from "../../../store/actions/auth";
import { connect } from "react-redux";

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: "1.125rem",
    lineHeight: "1.3125rem",
    fontWeight: 900,
    letterSpacing: "0.5px",
    marginBottom: theme.spacing(1)
  },
  subtitle: {
    fontSize: "0.875rem",
    lineHeight: "1rem",
    fontWeight: 500,
    color: theme.palette.secondary.main,
    letterSpacing: "-.1px"
  },
  label: {
    color: theme.palette.secondary.main,
    fontWeight: "bold",
    transform: "none"
  },
  card: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(3),
    backgroundColor: "#fff",
    borderRadius: theme.spacing(1),
    width: remCalc(432),
    boxSizing: "border-box"
  },
  btn: {
    padding: theme.spacing(1.25, 3),
    lineHeight: "1rem"
  },
  inputSection: {
    marginTop: theme.spacing(4)
  },
  mainInput: {
    "&.MuiInput-root": {
      marginTop: theme.spacing(1.5),
      fontSize: "0.9375rem"
    }
  },
  inputField: {
    width: "100%",
    height: theme.spacing(7.75)
  },
  cancelBtn: {
    backgroundColor: "#ECEEFF"
  },
  deleteBtn: {
    color: "#D93024",
    marginLeft: theme.spacing(1)
  },
  formControl: {
    width: "100%",
    marginTop: theme.spacing(3),
    "& .MuiFormControlLabel-root": {
      marginLeft: theme.spacing(-1),
      "& .MuiFormControlLabel-label": {
        fontSize: "0.9375rem"
      },
      "& .MuiRadio-root.Mui-checked svg": {
        color: theme.palette.primary.main
      },
      "& .MuiRadio-root": {
        padding: theme.spacing(1),
        marginRight: theme.spacing(0.375)
      }
    }
  },
  lineHeight20px: {
    lineHeight: "1.25rem"
  },
  textArea: {
    fontSize: "0.9375rem",
    lineHeight: "1.125rem",
    "&::placeholder": {
      color: theme.palette.secondary.main,
      opacity: 1
    }
  }
}));

function CancelSubscription({ handleClose, logout }) {
  const classes = useStyles();
  const [value, setValue] = useState("");

  const [optionsVisible, setOptionsVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [textareaValue, setTextareaValue] = useState("");

  const history = useHistory();

  const [selectedOption, setSelectedOption] = useState("");

  const handleSelect = e => {
    setTextareaValue("");
    setSelectedOption(e.target.value);
  };

  const handleTextareaChange = e => {
    console.log("eeeeee", e.target.value);
    setTextareaValue(e.target.value);
  };

  const handleChange = e => {
    if (e.target.value.toLowerCase().trim() === "cancel") {
      setOptionsVisible(true);
    } else {
      setOptionsVisible(false);
    }
    setValue(e.target.value);
  };

  const { enqueueSnackbar } = useSnackbar();

  const deleteSubscription = () => {
    setLoading(true);
    API.delete("v1/stripe/subscriptions", {
      data: {
        reason: selectedOption,
        message: textareaValue
      }
    })
      .then(res => {
        enqueueSnackbar(
          "Your subscription is cancelled. You have been logged out automatically."
        );
        logout();
        history.push("/");
      })
      .finally(() => setLoading(false));
  };

  return (
    <FadeContainer open={true} backgroundColor="#f9f9f9">
      {/* Loading */}
      <Fade in={loading} unmountOnExit mountOnEnter>
        <LoadingCircle />
      </Fade>
      <PricingHeader title={"Account cancellation"} handleClose={handleClose} />
      <Box
        pt={4}
        display="flex"
        alignItems="center"
        flexDirection="column"
        overflow="auto"
        pb={3}
      >
        <Box display="flex" className={clsx(classes.card)}>
          <div>
            <Typography className={classes.title}>
              We’re sorry to hear you’re leaving us!
            </Typography>
            <Typography className={classes.subtitle}>
              When you cancel, we will deactivate your account so logging in
              will no longer work.
            </Typography>
          </div>
          <div className={classes.inputSection}>
            <TextField
              type="text"
              helperText=" "
              value={value}
              fullWidth
              className={classes.inputField}
              InputProps={{
                className: classes.mainInput
              }}
              onChange={handleChange}
              label="To continue, please type CANCEL below"
              InputLabelProps={{ shrink: true, className: classes.label }}
              variant="outlined"
            />
          </div>

          {optionsVisible && (
            <Box mt={4}>
              <Typography
                className={clsx(classes.lineHeight20px, classes.subtitle)}
              >
                Please take a moment to tell us your main reason for leaving, it
                will help us improve in the future.
              </Typography>
              <FormControl component="fieldset" className={classes.formControl}>
                <RadioGroup
                  aria-label="gender"
                  name="gender2"
                  value={selectedOption}
                  onChange={handleSelect}
                >
                  <FormControlLabel
                    value="Routetitan doesn’t have features I need"
                    control={<Radio color="primary" />}
                    label="Routetitan doesn’t have features I need"
                  />
                  <Collapse
                    in={
                      selectedOption ===
                      "Routetitan doesn’t have features I need"
                    }
                    unmountOnExit
                    mountOnEnter
                  >
                    <Box mb={2} width="100%">
                      <TextField
                        multiline
                        fullWidth
                        onChange={handleTextareaChange}
                        value={textareaValue}
                        rows="4"
                        label=" "
                        InputProps={{ classes: { input: classes.textArea } }}
                        InputLabelProps={{ shrink: true }}
                        placeholder="Please tell us more about which features were lacking"
                      />
                    </Box>
                  </Collapse>
                  <FormControlLabel
                    value="I was working on a temporary project"
                    control={<Radio color="primary" />}
                    label="I was working on a temporary project"
                  />
                  <FormControlLabel
                    value="We are moving to a different solution"
                    control={<Radio color="primary" />}
                    label="We are moving to a different solution"
                  />
                  <FormControlLabel
                    value="I have a bad experience with Routetitan"
                    control={<Radio color="primary" />}
                    label="I have a bad experience with Routetitan"
                  />
                  <Collapse
                    in={
                      selectedOption ===
                      "I have a bad experience with Routetitan"
                    }
                    unmountOnExit
                    mountOnEnter
                  >
                    <Box mb={2} width="100%">
                      <TextField
                        multiline
                        fullWidth
                        onChange={handleTextareaChange}
                        value={textareaValue}
                        rows="4"
                        label=" "
                        InputProps={{ classes: { input: classes.textArea } }}
                        InputLabelProps={{ shrink: true }}
                        placeholder="Please tell us more about your unpleasant experience which will help us improve Routetitan"
                      />
                    </Box>
                  </Collapse>
                  <FormControlLabel
                    value="My business is seasonal"
                    control={<Radio color="primary" />}
                    label="My business is seasonal"
                  />
                  <FormControlLabel
                    value="Other"
                    control={<Radio color="primary" />}
                    label="Other"
                  />
                  <Collapse
                    in={selectedOption === "Other"}
                    unmountOnExit
                    mountOnEnter
                  >
                    <Box mb={2} width="100%">
                      <TextField
                        multiline
                        fullWidth
                        rows="4"
                        label=" "
                        onChange={handleTextareaChange}
                        value={textareaValue}
                        InputProps={{ classes: { input: classes.textArea } }}
                        InputLabelProps={{ shrink: true }}
                        placeholder="Please tell us more about why you are cancelling your subscription"
                      />
                    </Box>
                  </Collapse>
                </RadioGroup>
              </FormControl>
              <Box display="flex" justifyContent="flex-end" mt={5}>
                <Button
                  color="primary"
                  className={clsx(classes.btn, classes.cancelBtn)}
                  onClick={() => {
                    handleClose();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className={clsx(classes.btn, classes.deleteBtn)}
                  onClick={() => deleteSubscription()}
                  disabled={
                    value.toLowerCase().trim() !== "cancel" || !selectedOption
                  }
                >
                  Delete
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </FadeContainer>
  );
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps, { logout })(CancelSubscription);
